import { DialogContent, Stack } from "@mui/material";
import { FormProvider } from "src/components/hook-form";

import FormFooter from "./components/FormFooter";
import PasswordInput from "./components/PasswordInput";
import SecretNameInput from "./components/SecretNameInput";
import useCrateSecretForm from "./hooks/useCrateSecretForm";

export default function CrateSecretForm() {
	const { methods, onSubmit, isLoading } = useCrateSecretForm();

	return (
		<FormProvider autocomplete='off' methods={methods} onSubmit={onSubmit}>
			<DialogContent sx={{ mt: 0 }}>
				<Stack gap={3}>
					<SecretNameInput />
					<PasswordInput />
				</Stack>
			</DialogContent>
			<FormFooter isLoading={isLoading} />
		</FormProvider>
	);
}
